import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3070e614"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Evolução de consentimentos")
], -1))
const _hoisted_3 = {
  class: "card-toolbar",
  "data-kt-buttons": "true"
}
const _hoisted_4 = {
  key: 0,
  class: "card-body"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lds-dual-ring" }),
  /*#__PURE__*/_createElementVNode("p", null, "Carregando...")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "card-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card card-stretch consents-evolution", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1", {active : _ctx.checkPeriod('month')}]),
          id: "kt_charts_widget_3_year_btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePeriod('month')))
        }, "Mês", 2),
        _createElementVNode("a", {
          class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4 me-1", {active : _ctx.checkPeriod('week')}]),
          id: "kt_charts_widget_3_month_btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePeriod('week')))
        }, "Semana", 2),
        _createElementVNode("a", {
          class: _normalizeClass(["btn btn-sm btn-color-muted btn-active btn-active-primary px-4", {active : _ctx.checkPeriod('day')}]),
          id: "kt_charts_widget_3_week_btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePeriod('day')))
        }, "Dia", 2)
      ])
    ]),
    (_ctx.loadingState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.series)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "area",
                options: _ctx.options,
                series: _ctx.series,
                height: "280px"
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ]))
  ], 2))
}